<template>
  <div class="feedback__modal__btn">
    <b-button @click="$bvModal.show('feedbackModal')" v-b-tooltip.hover title="Send Feedback" class="feedback-btn" variant="theme">
      <i class="fas fa-question"></i>
    </b-button>
  </div>
</template>

<script>
export default { };
</script>

<style>
</style>